import React, { FC } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { Grid } from '@material-ui/core';
import { ContentInput } from 'api';
import { useReleases } from 'hooks';

import PhotoUpload from '../Thumbnails/PhotoUpload';

import { DraggableThumbnails, SelectableThumbnails } from '../Thumbnails';

const PhotoStrip: FC = () => {
  const releases = useReleases();
  const hasVariations = releases.includes('shareVariations');
  const { values } = useFormikContext<ContentInput>();
  const { photos } = values.content_object;

  return (
    <FieldArray name="content_object.photos">
      {arrayHelpers => (
        <Grid container spacing={1}>
          {hasVariations ? (
            <DraggableThumbnails arrayHelpers={arrayHelpers} images={photos} />
          ) : (
            <SelectableThumbnails photos={photos} />
          )}
          <Grid item>
            <PhotoUpload arrayHelpers={arrayHelpers} />
          </Grid>
        </Grid>
      )}
    </FieldArray>
  );
};

export default PhotoStrip;
